@if (isShowing) {
	<div class="d-flex justify-content-between align-items-center mb-1">
		<div class="fsemibold f32 text-capitalize">{{ mode }}</div>
		
        <a routerLink="{{ moreUrl }}" routerDirection="root" type="link" class="text-primary text-decoration-none cursor-pointer" *transloco="let t;">
            {{ t('button.see_all') }}
        </a>
	</div>
	
	@for (d of data; track d) {
		<ups-content-card class="mb-3" [data]="d" [isSquare]="true" />
	}
}
